import "isomorphic-fetch";
import promise from "es6-promise";
promise.polyfill();

const sectionData = () => {
  const show = "./assets/data/next-show-hr.json";
  const showEng = "./assets/data/next-show-eng.json";

  window.fetch(show)
    .then(res => res.json())
    .then(result => {
        return result;
      }, error => {
        // we don't swallow exceptions from actual bugs in components. // Note: it's important to handle errors here instead of a catch() block so that
        console.log(error);
      })
    .then(result => {
      populateSectionData(result);
    });
};

const populateSectionData = data => {
  const titleElement = document.querySelector(".js-next-title");
  const subtitleElement = document.querySelector(".js-next-subtitle");
  const excerpElement = document.querySelector(".js-next-excerp");

  titleElement.innerHTML = data[0].title;
  subtitleElement.innerHTML = data[0].place;
  excerpElement.innerHTML = data[0].excerp;
}

export {
  sectionData
};